import ContactList from './../components/ContactList.jsx';

const Contact = () => {
  return (
    <div>
      <ContactList/>
    </div>
  )
}

export default Contact